module.exports = __webpack_public_path__ + "static/media/gloriaRobertWedding47.976f4044.png";